<template>
  <div class="bgAmap-container" id="indexMap">
    <el-amap
      ref="map"
      vid="indexDemo"
      :center="center"
      :zoom="zoom"
      :amap-manager="amapManager"
      :events="mapEvents"
      class="index-demo"
    >
      <template v-for="(marker, index) in markers">
        <el-amap-marker
          v-if="marker && !isNaN(marker.longitude) && !isNaN(marker.latitude) && marker.longitude !== null && marker.latitude !== null"
          :key="index"
          :position="[Number(marker.longitude), Number(marker.latitude)]"
          :icon="marker.is_double?home_point_double:home_point"
          :offset="[-15, -40]"
          :events="{ click: () => markerClick(marker) }"
          :vid="index"
          :title="marker.title"
        >
        </el-amap-marker>
      </template>
    </el-amap>

    <!-- 路灯详情 -->
    <div v-if="mapDalogVisible" class="map-dialog-box">
      <div class="item_map">
        <div class="close-window" @click="closeWin()">
          <i class="el-icon-close"></i>
        </div>
        <h3 class="info-title" :title="lampInfo.name">
          {{ lampInfo.name }}
        </h3>
        <div class="info-content" v-html="getGasValue(lampInfo)"></div>
        <div class="info-controls">
          <div class="botton-one" @click="showSet(lampInfo)">
            <div class="icon">
              <svg-icon name="lamp-control"/>
            </div>
            <div class="text">路灯控制</div>
          </div>
          <div v-if="lampInfo.camera_list&&lampInfo.camera_list.length" class="botton-one" @click="videoPreview(lampInfo.camera_list[0])">
            <div class="icon">
              <svg-icon name="video-preview"/>
            </div>
            <div class="text">摄像头</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 设备控制设置 -->
    <div
      v-if="lightSetItem.visible"
      class="box_control_bg"
      @click="closeSet"
    ></div>
    <div v-if="lightSetItem.visible" class="box_control w750">
      <div class="box_head">
        <span class="box_title">{{ lightSetItem.title }}-{{$t('device.light_control')}}</span>
        <div class="box_close" @click="closeSet">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <light-set
          ref="lightSet"
          :setData="lightSetItem.lightSetData"
          @updated="getLampList()"
        ></light-set>
      </div>
    </div>


    <!-- 查看监控 -->
    <div
      class="box_control_bg"
      v-if="videoData.dialogVisible"
      @click="closeVideo"
    ></div>
    <div class="box_control" v-if="videoData.dialogVisible">
      <div class="box_head">
        <span class="box_title">查看路灯监控</span>
        <div class="box_close" @click="closeVideo">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <div class="video-left">
          <video-box
            ref="video_home_box"
            :video="videoData"
          ></video-box>
        </div>
        <div class="video-right">
          <video-control
            ref="video_home_control"
            :video="videoData"
          ></video-control>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
import VueAMap from "vue-amap";
import lampsApi from "@/api/device/lamps";
import cameraApi from "@/api/device/camera";
import videoControl from "@/components/video/VideoControl";
import videoBox from '@/components/video/VideoBox.vue'
import lightSet from "@/components/device/lamps/lightControl"
import { ACCOUNT_MAP } from '@/config/index.js';
let amapManager = new VueAMap.AMapManager();
export default {
  name: "bgAmap",
  components: {
    videoBox,
    lightSet,
    videoControl
  },
  data() {
    return {
      home_point: require('../../assets/home_images/home_point.png'),
      home_point_double: require('../../assets/home_images/home_point_double.png'),
      amapManager,
      mapEvents: {
        init(o) {
          o.setMapStyle("amap://styles/darkblue");
        },
      },
      zoom: 14,
      center: [],
      markers: [],
      videoData: {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      },
      lampInfo: {
        name: "",
        lamp_id: "",
        stg_id: "",
        stg_name: "",
        light: "",
        ms: "",
        sb: [],
        camera_list: [],
      },
      pageInfo: {
        sortBy: 'lamp_id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 500
      },
      videoData: {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      },
      mapDalogVisible: false,
      lightSetItem: {
        visible: false,
        title: "",
        lightSetData: {}
      }
    };
  },
  created() {
    let mapData = ACCOUNT_MAP
    const mapDataStr = localStorage.getItem('mapData');
    if(mapDataStr){
      mapData = JSON.parse(mapDataStr)
    }

    this.center = mapData.center

    this.getLampList();
  },
  methods: {
    init: function () {
      //地图初始化
      map = new AMap.Map("indexMap", {
        resizeEnable: true,
      });
    },
    getLampList() {
      lampsApi.lightList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          if(this.$store.state.user.role_type==1){
            this.zoom=8
          }else{
            this.zoom=14
          }
          this.markers = resData.list;
        }
      });
    },
    markerClick(marker) {
      this.lampInfo = marker
      this.mapDalogVisible = true
      
    },
    closeWin() {
      this.mapDalogVisible = false
    },
    getGasValue(items) {
      const doubleType = this.$t('device.doubleType'),
      steColorArr = ["valuegrey", "valuegreen"],
      steList = this.$t('device.steList'),
      lightStatusArr = ["valuegrey", "valueyellow"],
      lightStatus = this.$t('device.lightStatus'),
      msList = this.$t('device.msList')
      let str = ''
      str +="<div class='item-one'>" + this.$t('device.device_number') + "：<span>" + items.number + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.device_model') + "：<span>" + items.device_type_name + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.single_Double') + "：<span>" + doubleType[items.is_double] + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.switch_state') + "：<span class="+lightStatusArr[items.lights_status]+">" + lightStatus[items.lights_status] + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.light') + "：<span>" + items.brightness + msList[items.ms] + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.current_strategy') + "：<span>" + items.stg_name + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.online_status') + "：<span class="+steColorArr[items.ste]+">" + steList[items.ste] + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.group') + "：<span>" + items.group_name + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.current') + "：<span>" + items.current + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.voltage') + "：<span>" + items.voltage + "</span></div>";
      return str
    },
    videoPreview(video) {
      if (!this.video.number) {
        return
      }
      cameraApi.cameraInfo({
        number: video.number,
        channel: video.channel
      }).then((res) => {
        if (res.data.code === 1000) {
          this.videoData = {
            id: res.data.data.id,
            title: res.data.data.title,
            number: res.data.data.number,
            camera_type: res.data.data.camera_type,
            channel: res.data.data.channel,
            access_token: res.data.data.access_token,
            dialogVisible: true
          }
        }
      });
    },
    closeVideo() {
      this.videoData = {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      }
    },
    showSet(setting) {
      this.lightSetItem.title = setting.name
      this.lightSetItem.lightSetData = {
        lamp_id: setting.lamp_id,
        lamp_name: setting.name,
        is_double: parseInt(setting.is_double),
        light: setting.light,
        light2: setting.light2,
        stg_id: setting.stg_id,
        stg_name: setting.stg_name,
        ms: setting.ms
      }
      this.lightSetItem.visible = true
    },
    closeSet() {
      this.lightSetItem.visible = false
      this.lightSetItem.title = ''
      this.lightSetItem.lightSetData = {}
    }
  }
};
</script>

<style lang='less'>
@color-primary:#0c82fe;
.bgAmap-container {
  width:100%;
  height:100%;
  .index-demo {
    position: absolute;
    width:100%;
    height:100%;
    overflow: hidden;
    z-index: 1;
  }

  .amap-logo {
    display: none !important;
    opacity: 0 !important;
  }
  .amap-layers {
    background: #09152a !important;
  }

  
}

.video-left{
  width:600px;
  height:400px;
  float: left;
}
.video-right{
  float: right;
}

.map-dialog-box{
  width: 340px;
  min-height: 500px;
  position: absolute;
  z-index: 99;
  left:50%;
  top:50%;
  transform: translate(-50%,-50%);
  .item_map {
    background-image: url("../../assets/home_images/item_map.png");
    background-position: 0 0;
    background-size: 100% 100%;
    padding: 20px;
    border-radius: 20px;
    border: 2px solid #e8c255;
    position: relative;
    min-width: 200px;
    box-sizing: border-box;
    color: #fff;
    .close-window {
      width: 26px;
      height: 26px;
      border-radius: 26px;
      cursor: pointer;
      background: #413c33;
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center; /* 垂直居中 */
      position: absolute;
      top: 10px;
      right: 10px;
      color: #fff;
      z-index: 99999;
      i {
        color: #fff;
        font-size: 18px;
      }
    }
    .close-window:hover {
      background: #332d24;
    }
    h3.info-title {
      margin: 0 0 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 18px;
    }
    .info-content {
      padding:0 10px 10px;
      overflow: hidden;
      .item-one{
        width: 100%;
        display: flex;
        align-items: center;
        color:#c6dbe5;
        padding: 3px 0;
        line-height: 1.2;
        span{
          color:#FFFFFF;
        }
        .valuegreen {
          color: rgba(26, 151, 14, 0.856);
        }

        .valuered {
          color: rgba(241, 12, 4, 0.856);
        }

        .valueblue {
          color: #0c82fe;
        }

        .valueyellow {
          color: #febf2a;
        }

        .valuegrey {
          color: #bbb;
        }
      }
    }
    .info-controls {
      padding:5px 10px 10px;
      display: flex;
      align-items: center;
      .botton-one{
        margin-right: 20px;
        cursor: pointer;
        outline: none;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .icon{
          border: 1px solid rgba(255, 255, 255, 0.5);
          border-radius: 50%;
          width: 50px;
          height: 50px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 30px;
          background-color: #715f2a;
          color:#fff;
        }
        .text{
          padding: 5px 0;
          font-size: 14px;
          text-align: center;
          color:#fff;
        }
        &:hover{
          .icon{
            border: 1px solid rgba(255, 255, 255, 1);
            color:#fff;
            background-color: #8b7533;
          }
          .text{
            color:#8b7533;
          }
        }
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
}
</style>
